<template>
  <v-layout>
    <v-dialog v-model="showUpdateDialog"
              lazy
              @input="v => v"
              max-width="500">
      <v-card class="pa-4">
        <v-layout column>
          <span class="title mb-3">
            Update Load's Settlement Details
          </span>

          <v-text-field v-if="currentUserCanModifySettlementAmount"
                        label="Amount"
                        v-model="updatedAmount">
          </v-text-field>
          <template v-else>
            <span class="font-weight-light font-italic">
              The load
              <span v-if="settlement.customerCompany">dispatcher</span>
              <span v-else>{{$t('components.load-details.self-contracted').toLocaleLowerCase()}}</span>
              can modify the settlement amount.
            </span>
          </template>

          <template v-if="currentItemDelivered && currentUserCanModifySettlementDeliveryDetails">
            <v-text-field :label="billOfLadingNumberFieldLabel"
                          v-model="updatedBOL">
            </v-text-field>

            <v-text-field label="Head count"
                          v-model="updatedHeadCount">
            </v-text-field>
          </template>
          <template v-else>
            <span class="font-weight-light font-italic">
              Once a load is delivered, {{ $t('terms.bill-of-lading') }} number and final animal count can be
              corrected by the carrier if necessary.
            </span>
          </template>

          <v-card-actions>
            <v-spacer />
            <v-btn color="accent"
                   :loading="loadingBtn"
                   @click="saveUpdate()">
              Save
            </v-btn>
            <v-btn color="accent" flat
                   @click="showUpdateDialog = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-btn :color="color"
           :fab="fab"
           :small="small"
           :disabled="!!disabled"
           @click="openUpdateDialog"
           class="ma-0">
      <slot name="default">
        Update Details
      </slot>
    </v-btn>

  </v-layout>

</template>

<script>
import _ from 'lodash';
import * as Settlements from '@/types/models/settlement';
import API from '@/api/index';
import SettlementMixin from '@/mixins/settlementMixin';

export default {
  name: 'VUpdateSettlementBtn',
  mixins: [
    SettlementMixin,
  ],
  props: {
    settlement: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    fab: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'primary',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingBtn: null,
      updatedAmount: null,
      updatedBOL: null,
      updatedHeadCount: null,
      showUpdateDialog: null,
    };
  },
  computed: {
    currentItemDelivered() {
      return _.get(this.settlement, 'delivered');
      // const delivered = Settlements.delivered(this.settlement);
      // return delivered;
    },
    currentUserCanModifySettlementAmount() {
      return this.userCanModifySettlementAmount(this.settlement);
    },
    currentUserCanModifySettlementDeliveryDetails() {
      return this.userCanModifySettlementDeliveryDetails(this.settlement);
    },
    invioce() {
      return Settlements.invoice(this.settlement);
    },
    billOfLadingNumberFieldLabel() {
      return `${this.$t('terms.bill-of-lading')} Number`;
    },

  },
  methods: {
    openUpdateDialog() {
      this.updatedAmount = this.settlement.amount;
      this.updatedBOL = this.settlement.billOfLadingNumber;
      this.updatedHeadCount = _.get(this.settlement, 'animalCount');
      this.showUpdateDialog = true;
    },
    async saveUpdate() {
      this.loadingBtn = true;
      const body = {
        amount: this.updatedAmount,
        billOfLadingNumber: this.updatedBOL,
        animalCount: this.updatedHeadCount,
      };

      try {
        await API.settlements.update({ settlementId: this.settlement.id, body });

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Updated Settlement Item',
          timeout: 3000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
        this.showUpdateDialog = false;

        this.$emit('refresh');
      }
    },
  },
  created() {

  },
};
</script>



// WEBPACK FOOTER //
// src/components/settlement/UpdateSettlementDetails.vue